import { z } from "zod";

export const getSivDataCarIconsByStatusResponseSchema = z.array(
  z.object({
    uuid: z.uuid(),
    brand: z.string(),
    model: z.string(),
    year: z.number().int(),
    color: z.string(),
    url: z.string().nullable(),
  }),
);

export type GetSivDataCarIconsByStatusResponse = z.infer<
  typeof getSivDataCarIconsByStatusResponseSchema
>;
